module.exports = __webpack_public_path__ + "img/logo-small.d06b3821.png";